module.exports = __webpack_public_path__ + "static/Prejoin_DE-90ead64eb7a837071e335bf2c9b4dd13.pdf";